import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633dab0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopcart-stock-jp" }
const _hoisted_2 = { class: "send-address" }
const _hoisted_3 = { class: "send-address-title" }
const _hoisted_4 = { class: "send-address-content" }
const _hoisted_5 = { class: "jp-address" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "〒373-0012 群馬県太田市清原町10-1 シャッターNo.6置配", -1))
const _hoisted_8 = { class: "import-address" }
const _hoisted_9 = { class: "import-address-title flex" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fx-1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/stock_jp/add_icon.png",
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/stock_jp/edit_icon.png",
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "import-address-info" }
const _hoisted_15 = { class: "import-address-info-name" }
const _hoisted_16 = { class: "import-address-info-main" }
const _hoisted_17 = {
  key: 0,
  class: "address-line"
}
const _hoisted_18 = { class: "address-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "会社名:", -1))
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "address-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "法人番号:", -1))
const _hoisted_23 = { class: "name" }
const _hoisted_24 = { class: "address-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "メールアドレス:", -1))
const _hoisted_26 = { class: "name" }
const _hoisted_27 = { class: "address-line" }
const _hoisted_28 = { class: "address-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "地址:", -1))
const _hoisted_30 = { class: "name" }
const _hoisted_31 = { class: "address-item" }
const _hoisted_32 = { class: "title" }
const _hoisted_33 = { class: "name" }
const _hoisted_34 = {
  key: 0,
  class: "address-item"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "メールアドレス:", -1))
const _hoisted_36 = { class: "name" }
const _hoisted_37 = {
  key: 1,
  class: "empty"
}
const _hoisted_38 = { class: "options-express" }
const _hoisted_39 = { class: "options-content" }
const _hoisted_40 = { class: "options-title" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/stock_jp/edit_icon.png",
  alt: ""
}, null, -1))
const _hoisted_43 = { class: "options-list" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "express-content" }
const _hoisted_46 = { class: "express-title" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "must" }, "*"),
  /*#__PURE__*/_createElementVNode("span", null, "運送会社：")
], -1))
const _hoisted_48 = { class: "select" }
const _hoisted_49 = { class: "express-main" }
const _hoisted_50 = { class: "express-item" }
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "express-item" }
const _hoisted_53 = { class: "express-tip-warning" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/replenish/warning.png",
  alt: ""
}, null, -1))
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { class: "tariff-content" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tariff-title" }, "関税の納付方法", -1))
const _hoisted_58 = { class: "tariff-main" }
const _hoisted_59 = { class: "shopcart-stock-jp-table" }
const _hoisted_60 = { class: "shopcart-stock-table-title" }
const _hoisted_61 = { class: "table" }
const _hoisted_62 = { class: "tr head" }
const _hoisted_63 = {
  class: "th",
  style: {"width":"88px","text-align":"left"}
}
const _hoisted_64 = {
  class: "th",
  style: {"width":"138px"}
}
const _hoisted_65 = {
  class: "th",
  style: {"width":"138px"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "th",
  style: {"width":"138px"}
}, " THE CKB SKU ", -1))
const _hoisted_67 = {
  class: "th flex-center",
  style: {"width":"138px"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"600px","font-size":"14px"} }, [
  /*#__PURE__*/_createTextVNode(" 保管予定倉庫の選択について"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 商品をスムーズに出荷・納品するために、注文時はご希望の保管倉庫をあらかじめご選択ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "・【中国倉庫】を選択"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 商品は中国倉庫で検品後、エンドユーザー様へ直送されます。別倉庫への移動はできません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "・【日本倉庫】を選択"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 商品は中国倉庫で検品・良品登録された後、お客様ご自身による「日本倉庫への搬送依頼」が必要です。THE CKB指定ルートにて日本倉庫へ搬送され、最終的にエンドユーザー様へ出荷されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※注文時に日本倉庫を選択していない場合、後から搬送はできません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※倉庫の選択は後から変更できません。内容をご確認のうえご選択ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ご不明な点がございましたら、お気軽にカスタマーサービスまでお問い合わせください。 ")
], -1))
const _hoisted_69 = {
  class: "th",
  style: {"width":"138px"}
}
const _hoisted_70 = {
  class: "th",
  style: {"width":"138px"}
}
const _hoisted_71 = {
  class: "td",
  style: {"width":"88px","text-align":"left"}
}
const _hoisted_72 = {
  class: "td product-img",
  style: {"width":"138px"}
}
const _hoisted_73 = {
  class: "td",
  style: {"width":"138px"}
}
const _hoisted_74 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_75 = { class: "line--2" }
const _hoisted_76 = { style: {"margin-top":"5px"} }
const _hoisted_77 = {
  class: "td",
  style: {"width":"138px"}
}
const _hoisted_78 = {
  class: "td",
  style: {"width":"138px"}
}
const _hoisted_79 = {
  class: "td",
  style: {"width":"138px"}
}
const _hoisted_80 = {
  key: 0,
  class: "flex-center",
  style: {"color":"red","margin-top":"4px"}
}
const _hoisted_81 = {
  class: "td",
  style: {"width":"138px"}
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "create-content" }
const _hoisted_84 = { class: "text" }

import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import AddrForm from '@/views/setup/components/AddrForm.vue'
import { ref, reactive, onMounted, toRaw, computed, watch } from 'vue'
import useAddress from '@/views/inshipping/CreateShipping/useAddress'
import AddressConfig from '@/views/inshipping/components/AddressConfig.vue'
import { t } from '@/plugins/i18n'
import TariffConfig from '@/views/inshipping/components/TariffConfig.vue'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import { getCustomerShop } from '@/apis/order'
import AddProduct from '@/views/inshipping/components/AddProduct.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { QuestionFilled } from '@element-plus/icons-vue'
import {
  updateClearAddr
} from '@/apis/setup'
import { getAdtList } from '@/apis/addition'
import { getCountryListApi, getCountryExpressListApi, throughCountryGetExpressApi } from '@/apis/user'
import { getWarehouseByCountry, useRtfix, isD2C, expressCostPdf } from '@/store'
import { useRouter } from 'vue-router'
import {
  createDelivery
} from '@/apis/inShipping'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const allCheck = ref(false)
const form: any = reactive({})
const addVisible = ref(false)
const showAdt = ref(false)
const {
  showClearanceAddress,
  clearanceAddressConfig,
  addClearance,
  setDefaultClearanceAddress,
  openClearanceAddressVisible,
  showShippingAddress,
  shippingAddressConfig,
  addShipping,
  setDefaultShippingAddress,
  openShippingAddressVisible,
  provinces,
  selectShippingAddress,
  selectShippingAddressFn,
  selectClearanceAddress,
  selectClearanceAddressFn,
  refreshClearanceList,
  refreshShippingList,
  intShipTypeOption,
  intShipType,
  selectClearanceAddressChoice
}: Record<string, any> = useAddress(form)
const goodsList: any = ref([])
// watch(goodsList, () => {
//   console.log('watch', goodsList.value, goodsList.value.every(v => v.check))
//   allCheck.value = goodsList.value.length > 0 && goodsList.value.every(v => v.check)
// }, {
//   deep: true
// })
const allCheckChange = () => {
  allCheck.value = goodsList.value.length > 0 && goodsList.value.every(v => v.check)
}
const addressItem = ref({})
const intShipConfigId = ref('')
const update = (item: any) => {
  const { shopShippingAddressId, shopClearanceAddressId } = item
  const api = updateClearAddr
  if (!item.address) {
    item.address = item.addressEn
  }
  return api({
    ...item,
    defaultAddress: item.defaultAddress ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      form.declarationAddress = item
      ElMessage.success(t('修改成功'))
      refreshClearanceList(true)
    }
    return res.success
  })
}

const openAddressModal = (row?: any) => {
  addVisible.value = true
  addressItem.value = {
    ...row,
    isCreate: !row
  }
}
const editAddition = () => {
  showAdt.value = true
}
const deliveryAdditionalList = ref([])
const delAddition = (item) => {
  deliveryAdditionalList.value = deliveryAdditionalList.value.filter(v => v.additionCode !== item.additionCode)
}
const wareName = ref('')
const expresses = ref([])
onMounted(() => {
  if (!isD2C()) {
    router.replace(useRtfix('ShippingList'))
    return
  }
  getAdtList({ productType: 1, overseasInvFlag: 1 }).then(v => {
    const addition = v.data?.deliveryAdditionList ?? []
    deliveryAdditionalList.value = addition.filter(v => [23, 26].includes(v.additionCode))
    console.log('addition', addition)
  })
  getCustomerShop().then((res: any) => {
    if (res.success) {
      const warehouseList = res.data?.warehouseList ?? []
      // 表结构变了，换种形式获取仓库名称
      wareName.value = warehouseList.find((item: { warehouseCountry: string }) => item.warehouseCountry === 'CN')?.warehouseNameTranslate
    }
  })
  throughCountryGetExpressApi({
    countryCode: 'JP',
    // countryJpyName: countryItem.nameJa,
    systemSource: 1,
    warehouseCode: getWarehouseByCountry(),
    overseasInvFlag: 1
  }).then((res: any) => {
    if (res.success) {
      expresses.value = res.data
    }
  })
  const list = JSON.parse(window.localStorage.getItem('_transfer_jp_products_') || '[]')
  console.log('list', list)
  goodsList.value = list.map(v => ({
    ...v,
    quantity: v.overseasInvAvailableQuantity,
    useable: v.overseasInvAvailableQuantity
  }))
  allCheckChange()
  window.localStorage.setItem('_transfer_jp_products_', '[]')
})

const getData = () => {
  return {
    skuList: goodsList.value.map((v: any) => {
      return {
        num: v.quantity,
        productType: v.productType,
        productSku: v.productSku
      }
    }),
    countryCode: 'JP',
    systemSource: 1,
    warehouseCode: getWarehouseByCountry(),
    overseasInvFlag: 1
  }
}
const addProductVisible = ref(false)
const openProductModal = () => {
  addProductVisible.value = true
}
const submitGoodsCallback = (selectList: any[]) => {
  console.log('selectList', selectList)
  goodsList.value = [
    ...goodsList.value,
    ...selectList.map(v => ({
      ...v,
      quantity: v.overseasInvUseable,
      useable: v.overseasInvUseable
    }))
  ]
  allCheckChange()
}
const tariffConfig = ref()
const delGoods = (item) => {
  if (item.productSku) {
    goodsList.value = goodsList.value.filter(v => v.productSku !== item.productSku)
    allCheckChange()
    return
  }
  goodsList.value = goodsList.value.filter(v => !v.check)
  allCheckChange()
}
const submitLoading = ref(false)

const deliveryNums = computed(() => {
  return goodsList.value.reduce((total: number, v: any) => total + (v.quantity ?? 0), 0)
})

const submit = async () => {
  if (submitLoading.value) return
  // 关税
  let taxData = {}
  const hasTaxConfig = await tariffConfig.value.taxValid()
  if (!hasTaxConfig) {
    return
  }
  taxData = await tariffConfig.value.getTaxData()

  if (!form.declarationAddress?.shopClearanceAddressId) {
    ElMessage.warning(t('请选择清关地址'))
    return
  }
  if (!intShipConfigId.value) {
    ElMessage.warning(t('请选择物流公司'))
    return
  }
  if (!goodsList.value.length) { return ElMessage.warning(t('请选择商品')) }
  const {
    declarationAddress,
    receiverAddress,
    deliverTaskDetails,
    deliveryTitle,
    intForwarderConfigId,
    forwarder,
    deliveryType,
    distribution,
    allIncludeFlag,
    transportType
  } = toRaw(form)
  const submitForm: any = {
    deliveryNums: deliveryNums.value,
    deliveryTitle,
    deliveryType,
    distribution,
    forwarder,
    intForwarderConfigId,
    intShipConfigId: intShipConfigId.value,
    // 选其他则固定为false
    isOversea: false,
    ...taxData,
    goodsCountry: 'CN',
    allIncludeFlag,
    overseasInvFlag: 1,
    deliveryType: 1
  }
  // 收货地址
  submitForm.receiverAddress = {
    address: '清原町10-1 シャッターNo.6置配',
    clubCode: '-',
    companyName: 'The CKB',
    mobile: '070-8916-4664',
    name: 'The CKB',
    postalCode: '373-0012',
    nation: '2279',
    province: '168',
    // 个别地址没有市保存时需要为空
    city: '173',
    code: 'JP',
    countryCode: 'JP',
    email: ''
  }
  submitForm.receiverEnglishAddress = {
    address: '10-1 shutterNo.6 Kiyoharatyou',
    province: 'Gunma',
    city: 'Ota-shi',
    name: 'The CKB',
    nation: 'JP',
    companyName: 'The CKB',
    mobile: '070-8916-4664',
    postalCode: '373-0012'
  }

  submitForm.declarationAddress = {
    address: declarationAddress.addressEn,
    province: declarationAddress.areaEn,
    city: declarationAddress.cityEn,
    clubCode: declarationAddress.companyCode,
    companyName: declarationAddress.companyNameEn,
    mobile: declarationAddress.phone,
    name: declarationAddress.receiveNameEn,
    postalCode: declarationAddress.postalCode,
    nation: declarationAddress.nationCode,
    code: declarationAddress.nationCode,
    email: declarationAddress.email,
    clearanceCode: declarationAddress.clearanceCode,
    clearanceType: declarationAddress.clearanceType
  }
  submitForm.originalDeclarationAddress = {
    address: declarationAddress.address,
    province: declarationAddress.area,
    city: declarationAddress.city,
    clubCode: declarationAddress.companyCode,
    companyName: declarationAddress.companyName,
    mobile: declarationAddress.phone,
    name: declarationAddress.receiveName,
    postalCode: declarationAddress.postalCode,
    nation: declarationAddress.nationCode,
    code: declarationAddress.nationCode,
    email: declarationAddress.email,
    clearanceCode: declarationAddress.clearanceCode,
    clearanceType: declarationAddress.clearanceType
  }
  let isWarning = false
  submitForm.deliverTaskDetails = goodsList.value.map((e: any) => {
    if (Number(e.quantity) <= 0) {
      isWarning = true
    }
    console.log(e)
    submitForm.deliveryNums += Number(e.quantity)
    let data: Record<string, any> = {}
    data = {
      deliveryNums: Number(e.quantity),
      productSku: e.productSku,
      shopProductSku: e.shopProductSku
    }
    return data
  })
  if (isWarning) {
    ElMessage.warning(t('库存不足2'))
    return
  }
  submitForm.deliveryAdditionalList = deliveryAdditionalList.value.map(
    (e: any) => ({
      additionConfigId: e.additionConfigId,
      additionId: e.additionId,
      additionCode: e.additionCode,
      ingredientsSku: e.ingredientsSku
    })
  )

  submitLoading.value = true
  createDelivery(submitForm)
    .then((res: any) => {
      if (res.success) {
        submitLoading.value = false
        // ElMessage.success(t('国际发货创建成功'))
        goodsList.value = []
        ElMessageBox.confirm(t('发到日本的备货单创建成功'), t('提示'), {
          confirmButtonText: t('查看备货单详情'),
          cancelButtonText: t('留在当前页'),
          type: 'success'
        }).then(() => {
          router.push(useRtfix('ShippingInfo', { query: { deliveryTaskCode: res.data } }))
        })
      } else {
        submitLoading.value = false
      }
    })
    .catch(() => {
      submitLoading.value = false
    })
}
const changeAllCheck = (e) => {
  console.log(e)
  goodsList.value.forEach((item) => {
    item.check = e
  })
  allCheckChange()
}
const jumpExpressPrice = () => {
  if (!goodsList.value?.length) {
    ElMessage.warning(t('请选择商品'))
    return
  }
  // if (!declarationAddress.shopClearanceAddressId) {
  //   ElMessage.warning(t('当前清关地址不可用'))
  //   return
  // }
  // if (!declarationAddress.nationCode) {
  //   ElMessage.warning(t('请选择清关地址'))
  //   return
  // }
  const params = {
    membershipTemplateId: store.getters.user.membership?.membershipTemplateId,
    productParam: goodsList.value.map((item: any) => {
      return {
        additionList: [],
        num: item.quantity,
        productInfo: {
          productSellPrice: item.productSellPrice ?? item.unitPrice,
          productSkuImg: item.productSkuImg,
          productTitle: item.productTitle
        },
        productSellPrice: item.productSellPrice ?? item.unitPrice,
        productSku: item.productSku
      }
    }),
    shipParam: {
      countryCode: 'JP'
    }
  }
  window.localStorage.setItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`, JSON.stringify(params))
  window.open('/oem/utility/InterLogistics?from=inshipping&isStockJp=1')
}
const estimateIntShip = ref('')
const changeExpress = (id: any, item: any) => {
  estimateIntShip.value = item.priceCny
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('收货地址')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('日本仓收货地址')) + "：", 1),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('清关地址')) + "：", 1),
              _hoisted_11,
              _createElementVNode("div", {
                class: "import-address-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openClearanceAddressVisible) && _unref(openClearanceAddressVisible)(...args)))
              }, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('常用清关地址导入')), 1)
              ]),
              (_unref(form).declarationAddress?.shopClearanceAddressId)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "import-address-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (openAddressModal(_unref(form).declarationAddress)))
                  }, [
                    _hoisted_13,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('编辑地址')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_unref(form).declarationAddress?.shopClearanceAddressId)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_unref(form).declarationAddress?.receiveName), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(form).declarationAddress?.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_unref(form).declarationAddress?.clearanceType === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(form).declarationAddress?.companyName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(form).declarationAddress?.companyCode), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(form).declarationAddress?.email), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(form).declarationAddress?.countryName) + " " + _toDisplayString(_unref(form).declarationAddress?.provinceName) + " " + _toDisplayString(_unref(form).declarationAddress?.cityName) + " " + _toDisplayString(_unref(form).declarationAddress?.address), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('邮编')) + ":", 1),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(form).declarationAddress?.postalCode), 1)
                        ]),
                        (_unref(form).declarationAddress?.clearanceType === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(form).declarationAddress?.email), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(t)('请选择清关地址')), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('发货附加项')), 1),
                _createElementVNode("div", {
                  class: "edit-btn",
                  onClick: editAddition
                }, [
                  _hoisted_42,
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('编辑')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryAdditionalList.value, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "options-item",
                    key: i
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.additionNameJp), 1),
                    (![23, 26].includes(item.additionCode))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: "https://static-jp.theckb.com/static-asset/stock_jp/close_icon.png",
                          onClick: ($event: any) => (delAddition(item))
                        }, null, 8, _hoisted_44))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(ExpressSelect, {
                    id: intShipConfigId.value,
                    "onUpdate:id": _cache[2] || (_cache[2] = ($event: any) => ((intShipConfigId).value = $event)),
                    defaultExpress: expresses.value,
                    isStockJp: true,
                    countryCode: "CN",
                    "fee-tip": _unref(t)('请选择商品'),
                    getData: getData,
                    onChange: changeExpress
                  }, null, 8, ["id", "defaultExpress", "fee-tip"])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('店铺仓库所在地')) + "：" + _toDisplayString(wareName.value), 1),
                  _createElementVNode("a", {
                    class: "text",
                    href: _unref(expressCostPdf)(),
                    target: "_blank"
                  }, _toDisplayString(_unref(t)('国际料金表')), 9, _hoisted_51)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("span", null, "参考送料：" + _toDisplayString(estimateIntShip.value || '-') + "元", 1),
                  _createElementVNode("span", {
                    class: "text cursor-pt",
                    onClick: jumpExpressPrice
                  }, "👉 商品から送料を計算")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("span", {
              innerHTML: _unref(t)('国际料金表提示')
            }, null, 8, _hoisted_55)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("div", _hoisted_58, [
          _createVNode(TariffConfig, {
            ref: (_value, _refs) => {
              _refs['tariffConfig'] = _value
              tariffConfig.value = _value
            },
            isStockJp: true
          }, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", {
            class: "btn1",
            onClick: openProductModal
          }, _toDisplayString(_unref(t)('添加商品')), 1),
          _createElementVNode("div", {
            class: "btn2",
            onClick: delGoods
          }, _toDisplayString(_unref(t)('一键删除')), 1)
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_el_checkbox, {
                modelValue: allCheck.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((allCheck).value = $event)),
                onChange: changeAllCheck
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('全选')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(t)('图片')), 1),
            _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(t)('商品信息')), 1),
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createTextVNode(_toDisplayString(_unref(t)('可用库存')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _hoisted_68
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    color: "#999",
                    class: "cursor-pt",
                    style: {"margin-left":"4px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_69, _toDisplayString(_unref(t)('发货数量')), 1),
            _createElementVNode("div", _hoisted_70, _toDisplayString(_unref(t)('操作')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodsList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tr body",
              key: index
            }, [
              _createElementVNode("div", _hoisted_71, [
                _createVNode(_component_el_checkbox, {
                  modelValue: item.check,
                  "onUpdate:modelValue": ($event: any) => ((item.check) = $event),
                  key: item.productSku,
                  onChange: allCheckChange
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createVNode(ShoppingPreview, {
                  image: item.productSkuImg || item.productMainImg || ''
                }, null, 8, ["image"])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_el_tooltip, {
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_74, _toDisplayString(item.productTitle), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_75, _toDisplayString(item.productTitle), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_76, _toDisplayString(item.productPropertiesName), 1)
              ]),
              _createElementVNode("div", _hoisted_77, _toDisplayString(item.productSku), 1),
              _createElementVNode("div", _hoisted_78, _toDisplayString(item.useable), 1),
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_el_input_number, {
                  modelValue: item.quantity,
                  "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                  step: 1,
                  max: item.useable,
                  min: item.useable <= 0 ? 0 : 1,
                  size: "small",
                  "step-strictly": "",
                  disabled: item.useable <= 0
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "min", "disabled"]),
                (item.useable <= 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_unref(t)('库存不足2')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", {
                  class: "del-btn",
                  onClick: ($event: any) => (delGoods(item))
                }, _toDisplayString(_unref(t)('删除')), 9, _hoisted_82)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(t)('总发货数量')) + ": " + _toDisplayString(_unref(deliveryNums)), 1),
        _createVNode(_component_el_button, {
          class: "create-btn",
          loading: submitLoading.value,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('创建')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(AddressConfig, {
      visible: _unref(clearanceAddressConfig).visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(clearanceAddressConfig).visible) = $event)),
      config: _unref(clearanceAddressConfig),
      addApi: _unref(addClearance),
      setDefaultApi: _unref(setDefaultClearanceAddress),
      selectAddress: _unref(selectClearanceAddress),
      provinces: _unref(provinces),
      onRefresh: _unref(refreshClearanceList),
      onSelect: _unref(selectClearanceAddressFn),
      wareType: "CN",
      isStockJp: true
    }, null, 8, ["visible", "config", "addApi", "setDefaultApi", "selectAddress", "provinces", "onRefresh", "onSelect"]),
    (addVisible.value)
      ? (_openBlock(), _createBlock(AddrForm, {
          key: 0,
          visible: addVisible.value,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((addVisible).value = $event)),
          data: addressItem.value,
          "onUpdate:data": _cache[6] || (_cache[6] = ($event: any) => ((addressItem).value = $event)),
          name: "clear",
          update: update,
          defaultCountryCode: "CN"
        }, null, 8, ["visible", "data"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (showAdt.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              cfg: deliveryAdditionalList.value,
              "onUpdate:cfg": _cache[7] || (_cache[7] = ($event: any) => ((deliveryAdditionalList).value = $event)),
              onClose: _cache[8] || (_cache[8] = ($event: any) => (showAdt.value = false)),
              reback: "",
              type: "DeliAdt",
              title: _unref(t)('编辑国际物流附加项'),
              countryCode: "CN",
              isStockJp: true,
              mustAdditionId: ['23', '26'],
              hideAdtLoop: true
            }, null, 8, ["cfg", "title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    _createVNode(AddProduct, {
      visible: addProductVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((addProductVisible).value = $event)),
      "add-list": goodsList.value,
      type: 1,
      isStockJp: true,
      onGetList: submitGoodsCallback
    }, null, 8, ["visible", "add-list"])
  ], 64))
}
}

})